"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBrandByIdEndpointRequest = void 0;
function createBrandByIdEndpointRequest(brandId) {
    return {
        method: 'GET',
        endpoint: `brands/${brandId}`,
    };
}
exports.createBrandByIdEndpointRequest = createBrandByIdEndpointRequest;
